import React from 'react'
import LmsFullContentDetail from '../../features/addlms/LmsFullContentDetail'

const LmsFullContentDetailPage = () => {
  return (
   <LmsFullContentDetail/>
  )
}

export default LmsFullContentDetailPage
